<div class="container">
  <link rel="stylesheet" href="/helios.css" />
  @if (isListItem || !allContainersSelected) {
    @if (container.info.url) {
      <div class="color-muted"
      [innerText]="container.info.url"></div>
    }
    @if (container.info.address) {
      <div class="color-muted"
      [innerText]="container.info.address"></div>
    }
  }
</div>